import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '../../../../hooks/useApi/useFetchCreditCardTransaction';

type FC = FunctionComponent<vp.TransactionId>;

const CreditCardTransactionContainer: FC = (props: vp.TransactionId) => {
  const { TransactionID } = props;
  const [CreditCardTransaction, getCreditCardTransaction] = useFetchCreditCardTransaction({ bearer: '' });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.CreditCardTransactionResponse>();

  useEffect(() => {
    getCreditCardTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (CreditCardTransaction) {
      setTransaction(CreditCardTransaction);
    }
  }, [CreditCardTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <CreditCardTransactionInfo transaction={transaction} />}</div>;
};

export default CreditCardTransactionContainer;
